<template>
  <div class="index-page" >
      <div class="lefts"><indexLeft /></div>
      <div class="rights"><indexRight /></div>
    </div>
</template>
<script>
import indexLeft from "@/components/page/indexLeft.vue"; //头部
import indexRight from "@/components/page/indexRight.vue"; //头部
  export default {
    components: {
        indexLeft,
        indexRight
      },
    data(){
      return{

      }
    },
    watch:{

    },
    methods:{

    },
    created(){
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/page/indexTop.vue